module.exports = __webpack_public_path__ + "img/h5bg.13b78793.png";